import { render, staticRenderFns } from "./AddPaymentDetails.vue?vue&type=template&id=726462be&"
import script from "./AddPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./AddPaymentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports